module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/mail-3ff26e8d7df2ae383527689441a38243.svg";